import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faYoutube, faFacebook, faTwitter, } from "@fortawesome/free-brands-svg-icons";
import female from '../img/gender/female.png'
import male from '../img/gender/male.png'
import mixed from '../img/gender/mixed.png'
import founded from '../img/icon/found.png'
import country from '../img/icon/flag.png'
import sportsType from '../img/icon/football.png'
import gender from '../img/icon/male-gender-sign.png'
import './LeagueInfo.css'


const LeagueInfo = () => {

    const { league_id } = useParams();
    const [leagueID, setLeagueID] = useState([]);

    let bgColorChange;

    const { strBadge, strLeague, strSport, strCountry,
        strGender, intFormedYear, strDescriptionEN,
        strTwitter, strFacebook, strYoutube } = leagueID;

    useEffect(() => {
        const url = `https://www.thesportsdb.com/api/v1/json/1/lookupleague.php?id=${league_id}`
        fetch(url)
            .then(res => res.json())
            .then(data => setLeagueID(data.leagues[0]))
            .catch(error => console.log(error));
    }, [league_id])

    const genderImgChose = (type) => {
        if (type === 'Female') {
            return female
        } else if (type === 'Mixed') {
            return mixed;
        } else {
            return male
        }
    }

    // click at ==> (Formula 1) | 
    // its work there...
    if (strGender === 'Mixed') {
        bgColorChange = true;
    }


    return (
        <main>
            <section class="banner-container">
                <div class="container-fluid">
                    <div class="row">
                        <div class="banner-image">
                            <div class="banner-overlay"></div>
                            <h1 class="banner-title d-flex justify-content-center align-items-center">
                                <img src={strBadge} alt="" style={{ width: '200px' }} />
                            </h1>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container mt-3 mb-5">

                <div className="row leagues_info"
                    style={{ backgroundColor: bgColorChange ? '#ff6948' : '#2659c5' }}>

                    <div className="col-md-7 mt-2 fontColor">
                        <h3> {strLeague}</h3>
                        <p><img src={founded} alt="" className="logo" /> Founded: {intFormedYear}</p>
                        <p><img src={country} alt="" className="logo" /> Country: {strCountry}</p>
                        <p><img src={sportsType} alt="" className="logo" /> Sports Type: {strSport}</p>
                        <p><img src={gender} alt="" className="logo" /> Gender: {strGender}</p>
                    </div>

                    <div className="col-md-5 gander_img">
                        <img src={genderImgChose(strGender)} alt="" />
                    </div>

                </div>

                <div className="row mt-2 p-4 text-justify">
                    <p>{strDescriptionEN}</p>
                </div>

                <div className="row d-flex justify-content-center mt-4">
                    <a href={`https://${strTwitter}`} target="_blank" rel="noreferrer" className="twitter social">
                        <FontAwesomeIcon icon={faTwitter} size="2x" />
                    </a>
                    <a href={`https://${strFacebook}`} target="_blank" rel="noreferrer" className="facebook social">
                        <FontAwesomeIcon icon={faFacebook} size="2x" />
                    </a>
                    <a href={`https://${strYoutube}`} target="_blank" rel="noreferrer" className="youtube social">
                        <FontAwesomeIcon icon={faYoutube} size="2x" />
                    </a>
                </div>

            </section>
        </main>
    );
};

export default LeagueInfo;